import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { articles } from '../data/articles';
export function BlogArticlePage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  if (!slug || !articles[slug]) {
    return <Navigate to="/blog" replace data-id="element-174" />;
  }
  const article = articles[slug];
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-175">
      <Navigation data-id="element-176" />

      <main className="max-w-[640px] mx-auto px-6 sm:px-8 pt-28 sm:pt-36 pb-24 sm:pb-32" data-id="element-177">
        {/* Back link */}
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#9B9B9B] hover:text-[#5C5C5C] transition-colors mb-10" data-id="element-178">
          <ArrowLeft className="w-3.5 h-3.5" data-id="element-179" />
          Back to blog
        </Link>

        {/* Article header */}
        <header className="mb-16" data-id="element-180">
          <div className="flex items-center gap-3 mb-5" data-id="element-181">
            <span className="text-[13px] font-medium text-[#9B9B9B]" data-id="element-182">
              {article.category}
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-semibold text-[#0F0F0F] tracking-tight leading-[1.2] mb-4" data-id="element-183">
            {article.title}
          </h1>
          
        </header>

        {/* Article content */}
        <div className="space-y-12" data-id="element-184">
          {article.sections.map((section, i) => <section key={i} data-id="element-185">
              {section.heading && <h2 className="text-xl sm:text-[22px] font-medium text-[#0F0F0F] tracking-tight leading-snug mb-5" data-id="element-186">
                  {section.heading}
                </h2>}
              <div className="space-y-4" data-id="element-187">
                {section.paragraphs.map((paragraph, j) => <p key={j} className="text-[15.5px] text-[#3D3D3D] leading-[1.75]" data-id="element-188">
                    {paragraph}
                  </p>)}
              </div>
            </section>)}
        </div>

        {/* End divider */}
        <div className="mt-20 pt-10 border-t border-[#E8E6E3]" data-id="element-189">
          <Link to="/blog" className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#9B9B9B] hover:text-[#5C5C5C] transition-colors" data-id="element-190">
            <ArrowLeft className="w-3.5 h-3.5" data-id="element-191" />
            Back to blog
          </Link>
        </div>
      </main>

      <Footer data-id="element-192" />
    </div>;
}